var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangerPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74808 16.779L12.25 10.4443L21.7519 16.779C22.5752 17.3278 22.1866 18.611 21.1972 18.611H3.30278C2.31337 18.611 1.92484 17.3278 2.74808 16.779Z",
    stroke: "#1D474F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 7.04167C10.209 5.91409 11.1231 5 12.2507 5C13.3782 5 14.2923 5.91409 14.2923 7.04167C14.2923 8.16925 13.3782 9.08333 12.2507 9.08333V10.4444",
    stroke: "#1D474F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1265 4.72998V10.4442",
    stroke: "#FFE68E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 7.58691L22.9837 7.58691",
    stroke: "#FFE68E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerPlus);
export default __webpack_public_path__ + "static/media/hangerPlus.002da273d5381bc876a8cfcbd8e24a5f.svg";
export { ForwardRef as ReactComponent };